export const TipoEmendaParlamentar = {
  MUNICIPAL: 'MUNICIPAL',
  FEDERAL: 'FEDERAL',
  ESTADUAL: 'ESTADUAL'
};
